import axios from 'axios';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL });

export const setAuthToken = (token) => { if (token) { api.defaults.headers.common['Authorization'] = `Bearer ${token}`; localStorage.setItem('token', token); } else { delete api.defaults.headers.common['Authorization']; localStorage.removeItem('token'); } };
export const getToken = () => localStorage.getItem('token');
export const initAuth = () => { const t = getToken(); if (t) setAuthToken(t); };

export const auth = {
  register: async (email, password, name) => { const r = await api.post('/auth/register', { email, password, name }); setAuthToken(r.data.token); return r.data; },
  login: async (email, password) => { const r = await api.post('/auth/login', { email, password }); if (r.data.token) setAuthToken(r.data.token); return r.data; },
  logout: () => { setAuthToken(null); localStorage.removeItem('admin_path'); localStorage.removeItem('session_id'); },
  getMe: async () => (await api.get('/auth/me')).data,
  setup2FA: async (tempToken) => (await api.post('/auth/2fa/setup', {}, { headers: { 'Authorization': `Bearer ${tempToken}` } })).data,
  verify2FASetup: async (code, tempToken) => { const r = await api.post('/auth/2fa/verify-setup', { code, temp_token: tempToken }); setAuthToken(r.data.token); if (r.data.admin_path) localStorage.setItem('admin_path', r.data.admin_path); if (r.data.session_id) localStorage.setItem('session_id', r.data.session_id); return r.data; },
  verify2FA: async (code, tempToken) => { const r = await api.post('/auth/2fa/verify', { code, temp_token: tempToken }); setAuthToken(r.data.token); if (r.data.admin_path) localStorage.setItem('admin_path', r.data.admin_path); if (r.data.session_id) localStorage.setItem('session_id', r.data.session_id); return r.data; },
  send2FACode: async (tempToken) => (await api.post('/auth/2fa/send-code', {}, { headers: { 'Authorization': `Bearer ${tempToken}` } })).data,
  reset2FA: async (targetUserId) => (await api.post('/auth/2fa/reset', { target_user_id: targetUserId })).data,
};
export const products = {
  getAll: async (params) => (await api.get('/products', { params })).data,
  getOne: async (id) => (await api.get(`/products/${id}`)).data,
};
export const adminProducts = {
  getAll: async () => (await api.get('/admin/products')).data,
  create: async (d) => (await api.post('/admin/products', d)).data,
  update: async (id, d) => (await api.put(`/admin/products/${id}`, d)).data,
  delete: async (id) => (await api.delete(`/admin/products/${id}`)).data,
  uploadImages: async (id, files) => { const fd = new FormData(); files.forEach(f => fd.append('files', f)); return (await api.post(`/admin/products/${id}/images`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data; },
  reorderImages: async (id, images) => (await api.put(`/admin/products/${id}/images`, { images })).data,
  deleteImage: async (id, imageUrl) => (await api.delete(`/admin/products/${id}/images?image_url=${encodeURIComponent(imageUrl)}`)).data,
};
export const cart = {
  get: async (sid) => (await api.get('/cart', { headers: sid ? { 'session-id': sid } : {} })).data,
  add: async (item, sid) => (await api.post('/cart/add', item, { headers: sid ? { 'session-id': sid } : {} })).data,
  update: async (item, sid) => (await api.put('/cart/update', item, { headers: sid ? { 'session-id': sid } : {} })).data,
  remove: async (pid, size, sid) => (await api.delete(`/cart/remove?product_id=${pid}&size=${size}`, { headers: sid ? { 'session-id': sid } : {} })).data,
};
export const checkout = {
  createSession: async (d) => (await api.post('/checkout/session', d)).data,
  getStatus: async (sid) => (await api.get(`/checkout/status/${sid}`)).data,
};
export const orders = {
  getMine: async () => (await api.get('/orders')).data,
  getAll: async (params = {}) => (await api.get('/admin/orders', { params })).data,
  getDetail: async (id) => (await api.get(`/admin/orders/${id}`)).data,
  updateStatus: async (id, d) => (await api.put(`/admin/orders/${id}/status`, d)).data,
  updateTracking: async (id, d) => (await api.put(`/admin/orders/${id}/tracking`, d)).data,
  addNote: async (id, d) => (await api.post(`/admin/orders/${id}/notes`, d)).data,
  bulkStatus: async (d) => (await api.put('/admin/orders/bulk/status', d)).data,
  bulkTracking: async (d) => (await api.put('/admin/orders/bulk/tracking', d)).data,
  resendNotification: async (id) => (await api.post(`/admin/orders/${id}/resend-notification`)).data,
  exportCSV: (params = {}) => { const qs = new URLSearchParams(params).toString(); window.open(`${API_URL}/admin/orders/export/csv?${qs}`, '_blank'); },
};
export const crm = {
  getDashboard: async () => (await api.get('/admin/crm/dashboard')).data,
  getCustomers: async (params = {}) => (await api.get('/admin/crm/customers', { params })).data,
  getCustomerProfile: async (id) => (await api.get(`/admin/crm/customers/${id}`)).data,
  updateTags: async (id, tags) => (await api.put(`/admin/crm/customers/${id}/tags`, { tags })).data,
  updateLifecycle: async (id, stage) => (await api.put(`/admin/crm/customers/${id}/lifecycle`, { lifecycle_stage: stage })).data,
  addNote: async (id, d) => (await api.post(`/admin/crm/customers/${id}/notes`, d)).data,
  getNotes: async (id) => (await api.get(`/admin/crm/customers/${id}/notes`)).data,
  toggleAdmin: async (id) => (await api.put(`/admin/crm/customers/${id}/toggle-admin`)).data,
  gdprDelete: async (id) => (await api.delete(`/admin/crm/customers/${id}/gdpr-delete`)).data,
  getSegments: async () => (await api.get('/admin/crm/segments')).data,
  getTickets: async (params = {}) => (await api.get('/admin/crm/support', { params })).data,
  createTicket: async (d) => (await api.post('/admin/crm/support', d)).data,
  getTicket: async (id) => (await api.get(`/admin/crm/support/${id}`)).data,
  updateTicketStatus: async (id, status) => (await api.put(`/admin/crm/support/${id}/status`, { status })).data,
  addTicketMessage: async (id, text) => (await api.post(`/admin/crm/support/${id}/message`, { text })).data,
  getAbandonedCarts: async () => (await api.get('/admin/crm/abandoned-carts')).data,
  recoverCart: async (id) => (await api.put(`/admin/crm/abandoned-carts/${id}/recover`)).data,
  getAutomations: async () => (await api.get('/admin/crm/automations')).data,
  updateAutomation: async (id, d) => (await api.put(`/admin/crm/automations/${id}`, d)).data,
  getAutomationLogs: async () => (await api.get('/admin/crm/automations/logs')).data,
  setupAdmin: async () => (await api.post('/admin/setup')).data,
};
export const emailTemplates = {
  getAll: async () => (await api.get('/admin/email-templates')).data,
  update: async (type, d) => (await api.put(`/admin/email-templates/${type}`, d)).data,
};
export const contact = { submit: async (d) => (await api.post('/contact', d)).data };
export const upload = { file: async (f) => { const fd = new FormData(); fd.append('file', f); return (await api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data; } };
export const tracking = {
  getOrder: async (id) => (await api.get(`/track/${id}`)).data,
  lookup: async (orderId, email) => (await api.post('/track/lookup', { order_id: orderId, email })).data,
};
export const discountCodes = {
  getAll: async () => (await api.get('/admin/discount-codes')).data,
  create: async (d) => (await api.post('/admin/discount-codes', d)).data,
  delete: async (id) => (await api.delete(`/admin/discount-codes/${id}`)).data,
  toggle: async (id) => (await api.put(`/admin/discount-codes/${id}/toggle`)).data,
  apply: async (code, subtotal) => (await api.post('/discount/apply', { code, subtotal })).data,
};
export const userOrders = {
  getAll: async () => (await api.get('/orders')).data,
  getById: async (id) => (await api.get(`/orders/${id}`)).data,
};
export const emailAdmin = {
  sendTestEmail: async () => (await api.post('/admin/test-email')).data,
  triggerAbandonedCartCheck: async () => (await api.post('/admin/trigger-abandoned-cart-check')).data,
  previewTemplate: async (type) => (await api.get(`/admin/email-templates/${type}/preview`)).data,
  sendTestTemplate: async (type, toEmail) => (await api.post('/admin/email-templates/send-test', { template_type: type, to_email: toEmail || '' })).data,
  getStats: async () => (await api.get('/admin/email-stats')).data,
};

export const securityAdmin = {
  getDashboard: async () => (await api.get('/admin/security/dashboard')).data,
  getAuditLog: async (limit = 50) => (await api.get(`/admin/security/audit-log?limit=${limit}`)).data,
  getAdminUsers: async () => (await api.get('/admin/security/admin-users')).data,
  createAdmin: async (data) => (await api.post('/admin/security/create-admin', data)).data,
  updateRole: async (id, role) => (await api.put(`/admin/security/users/${id}/role`, { admin_role: role })).data,
  suspendAdmin: async (id) => (await api.put(`/admin/security/users/${id}/suspend`)).data,
  // Sessions
  getSessions: async () => (await api.get('/admin/security/sessions')).data,
  getAllSessions: async () => (await api.get('/admin/security/all-sessions')).data,
  killSession: async (sid) => (await api.delete(`/admin/security/sessions/${sid}`)).data,
  killOtherSessions: async () => (await api.delete('/admin/security/sessions')).data,
  // Admin path
  getAdminPath: async () => (await api.get('/admin/security/admin-path')).data,
  rotateAdminPath: async () => (await api.post('/admin/security/rotate-admin-path')).data,
  // IP Allowlist
  getIPAllowlist: async () => (await api.get('/admin/security/ip-allowlist')).data,
  addIP: async (ip, label, notes) => (await api.post('/admin/security/ip-allowlist', { ip, label, notes })).data,
  removeIP: async (ip) => (await api.delete(`/admin/security/ip-allowlist/${ip}`)).data,
  setIPMode: async (mode) => (await api.put('/admin/security/ip-allowlist-mode', { mode })).data,
  // GDPR
  exportCustomerData: async (userId) => (await api.get(`/admin/gdpr/export/${userId}`)).data,
  getConsentLog: async (userId) => (await api.get('/admin/gdpr/consent-log', { params: userId ? { user_id: userId } : {} })).data,
  // Permission audit
  getPermissionAudit: async () => (await api.get('/admin/security/permission-audit')).data,
  // 2FA reset
  reset2FA: async (userId) => (await api.post('/auth/2fa/reset', { target_user_id: userId })).data,
};
export const wishlist = {
  get: async () => (await api.get('/wishlist')).data,
  add: async (pid) => (await api.post(`/wishlist/${pid}`)).data,
  remove: async (pid) => (await api.delete(`/wishlist/${pid}`)).data,
};
